module.exports = __webpack_public_path__ + "static/hallenstadion-bg-95b4c6866f57abba602167a47387333b.jpg";